export default function BackIcon(props) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.69 8l6.11 6.223L11.053 16 3.199 8l7.855-8 1.745 1.778L6.69 8z"
        fill={props.fill}
      />
    </svg>
  )
}
